import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import PageHeader from "../components/PageHeader";
import EmptyState from "../components/EmptyState";
import NewsCard from "../components/home/NewsCard";
import { Reveal } from "../components/Reveal";
import api from "../lib/api";
import { IMAGES } from "../lib/site";

export default function Actualites() {
  const [articles, setArticles] = useState(null);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("");

  useEffect(() => {
    api.get("/meta/categories").then((r) => setCategories(r.data.article_categories)).catch(() => {});
  }, []);

  useEffect(() => {
    setArticles(null);
    const q = active ? `?category=${encodeURIComponent(active)}` : "";
    api.get(`/articles${q}`).then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, [active]);

  return (
    <>
      <SEO title="Actualités" description="Toutes les actualités du Club Cycliste Le Boulou : club, équipes, compétitions, résultats, partenaires et projet Sénégal." />
      <PageHeader kicker="La vie du club" title="Actualités" image={IMAGES.gear} />

      <div className="sticky top-20 z-30 bg-white/90 backdrop-blur-xl border-b border-navy/10">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 flex gap-2 overflow-x-auto py-4" data-testid="news-filters">
          <button
            data-testid="filter-all"
            onClick={() => setActive("")}
            className={`shrink-0 font-heading uppercase tracking-wider text-xs px-4 py-2 border transition-[background-color,color,border-color] duration-300 ${
              active === "" ? "bg-rouge border-rouge text-white" : "border-navy/20 text-navy/70 hover:border-rouge hover:text-rouge"
            }`}
          >
            Toutes
          </button>
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
              onClick={() => setActive(c)}
              className={`shrink-0 font-heading uppercase tracking-wider text-xs px-4 py-2 border transition-[background-color,color,border-color] duration-300 ${
                active === c ? "bg-rouge border-rouge text-white" : "border-navy/20 text-navy/70 hover:border-rouge hover:text-rouge"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <section className="py-20 sm:py-24">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          {articles === null ? null : articles.length === 0 ? (
            <EmptyState
              title="Aucun article publié pour le moment"
              message="Le club publiera bientôt ses premières actualités ici. Revenez vite !"
              testId="news-empty"
            />
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-grid">
              {articles.map((a, i) => (
                <Reveal key={a.id} delay={i * 0.06}>
                  <NewsCard article={a} index={i} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
